import { AiImageGenerateTrigger } from "./ai-image-generate-trigger";
import { AiImageSettings } from "./ai-image-settings";
import { AiImagePromptAreaTextarea } from "./ai-image-textarea";
import { UploadFilePreviews } from "./ai-image-upload-file-previews";
import { AiImageUploadReference } from "./ai-image-upload-reference";
import { AiImagesSettingsOptions } from "./ai-images-settin-options";

export const AiImagePromptArea = ({
  handleGenerateImage,
}: {
  handleGenerateImage: () => void;
}) => {
  return (
    <div className="tw-bg-white tw-flex tw-flex-col tw-mb-6 tw-relative tw-rounded-2xl tw-border tw-border-solid tw-border-blue-100 tw-pt-4 tw-px-2 tw-pb-2 tw-max-w-full">
      <AiImagePromptAreaTextarea />
      <AiImageUploadReference />
      <UploadFilePreviews />
      <div className="tw-flex tw-items-center tw-justify-between tw-relative tw-z-1">
        <AiImageSettings />
        <div className="tw-flex tw-items-center tw-gap-2">
          <AiImagesSettingsOptions />
          <AiImageGenerateTrigger handleGenerateImage={handleGenerateImage} />
        </div>
      </div>
    </div>
  );
};
